/** @format */

import React, { useState } from 'react';
import './styles.scss';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLongArrowRight,
  faLongArrowLeft
} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { getImagePosition } from 'utils/layout';
import separator from 'assets/images/images/section-break.png';

const ELEMENT_IDS = {
  CONTACT_FORM: 'leads-form',
  FIRST_SECTION: 'main-section-heading',
  LAST_SECTION: 'last-section-heading',
  DESCRIPTION_SECTION_BASE: 'description-section-heading'
};

export default function ArticleLayout({
  banner,
  subIcon,
  subIcon1,
  text,
  isMobileView,
  children = null,
  showFocusButtons = false,
  SpecialSection = null
}) {
  const [showFloatingNavMenu, setShowFloatingNavMenu] = useState(true);

  const getClassNameSection = isMobileView
    ? 'mobile-articlepage-section'
    : 'articlepage-section';

  function getBtnColor(index) {
    let buttonColor = 'btn-white';
    if (index == 1) {
      buttonColor = 'btn-pink';
    }

    return buttonColor;
  }

  const toggleFloatingNavMenu = () => {
    setShowFloatingNavMenu(!showFloatingNavMenu);
  };

  const getFloatingNavMenuStatus = () => {
    return showFloatingNavMenu ? 'show' : 'hide';
  };

  const ParagraphHeading = ({ text = null, id }) => {
    if (text) {
      return (
        <div id={id} className='heading-container'>
          <p className='text1'>{text}</p>
        </div>
      );
    }

    return <></>;
  };

  const ParagraphBody = ({ text = null, className = 'text2r' }) => {
    if (text) {
      const seperatedDesc = text.split('\n');

      return seperatedDesc.map((paragraph, index) => (
        <p key={index} className={className}>
          {paragraph}
        </p>
      ));
    }

    return <></>;
  };

  const SpecialButtonsRow = () => {
    const scrollToFocus = (elementId) => {
      elementId = ELEMENT_IDS.LAST_SECTION; // temprily set to always focus on last header
      const calculateOffset = () => {
        let initialOffSet = -220;
        if (isMobileView) {
          initialOffSet = -115;
        }
        // if (elementId === ELEMENT_IDS.CONTACT_FORM) {
        //   initialOffSet = initialOffSet + -60;
        // }

        return initialOffSet;
      };

      const element = document.getElementById(elementId);

      if (element) {
        setShowFloatingNavMenu(false);
        if (isMobileView || elementId === ELEMENT_IDS.CONTACT_FORM) {
          // const yOffset = -200;
          const yOffset = calculateOffset();
          window.scrollTo({
            top: element.getBoundingClientRect().top + window.scrollY + yOffset,
            behavior: 'smooth'
          });
        } else {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    };

    if (showFocusButtons) {
      const SpecialLinks = () => (
        <>
          {text?.links?.main_para?.text && (
            <span onClick={() => scrollToFocus(ELEMENT_IDS.FIRST_SECTION)}>
              {text?.links?.main_para?.text}
            </span>
          )}

          {text?.descriptions &&
            text.descriptions.map(({ link }, key) => {
              if (link?.text) {
                return (
                  <span
                    key={key}
                    onClick={() =>
                      scrollToFocus(
                        `${ELEMENT_IDS.DESCRIPTION_SECTION_BASE}-${key}`
                      )
                    }>
                    {link.text}
                  </span>
                );
              }
            })}

          <span onClick={() => scrollToFocus(ELEMENT_IDS.CONTACT_FORM)}>
            Kontakt
          </span>

          {text?.links?.second_para?.text && (
            <span onClick={() => scrollToFocus(ELEMENT_IDS.LAST_SECTION)}>
              {text?.links?.second_para?.text}
            </span>
          )}
        </>
      );

      return (
        <>
          <div
            className={`special-buttons-bubble-menu ${getFloatingNavMenuStatus()} pink`}
            onClick={() => toggleFloatingNavMenu()}>
            <span>Meny</span>
            <svg
              width='18'
              height='18'
              viewBox='0 0 18 18'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M16 2L2 16'
                stroke='currentColor'
                strokeWidth='3.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M2 2L16 16'
                stroke='currentColor'
                strokeWidth='3.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </div>
          <div
            className={`special-buttons-floating-menu ${getFloatingNavMenuStatus()} pink`}>
            <SpecialLinks />
          </div>
          <div className='special-buttons-section'>
            <SpecialLinks />
          </div>
        </>
      );
    }

    return <></>;
  };

  return (
    <div className='articlepage-container'>
      <h2 className='articlepage-main-title'>{text.heading}</h2>
      <SpecialButtonsRow />
      <div className='articlepage'>
        <div className='main-image-container'>
          <img
            src={banner}
            className='articlepage image-article-page-1'
            alt='header image'
          />
        </div>

        {SpecialSection && <SpecialSection />}

        <ParagraphHeading
          id={ELEMENT_IDS.FIRST_SECTION}
          text={text?.headings?.main_para}
        />
        <ParagraphBody text={text?.main_para} />
      </div>

      {text?.descriptions &&
        text.descriptions.map(({ text: articleText, props, heading }, key) => (
          <div key={key}>
            {isMobileView ? (
              <div
                className={`${getClassNameSection} articlepage-text-bottom-spacing`}>
                <img
                  src={`${key > 0 ? subIcon1 : subIcon}`}
                  className='mobile-articlepage-image-spacing'
                  alt={props.alt}
                />

                <ParagraphHeading
                  id={`${ELEMENT_IDS.DESCRIPTION_SECTION_BASE}-${key}`}
                  text={heading?.text}
                />
                <ParagraphBody text={articleText} />
              </div>
            ) : (
              <div
                className={`${getClassNameSection} articlepage-text-bottom-spacing`}>
                {props.imagePosition === 'left' && (
                  <img src={subIcon1} alt={props.alt} />
                )}
                <div className='description-heading-wrapper'>
                  <ParagraphHeading
                    id={`${ELEMENT_IDS.DESCRIPTION_SECTION_BASE}-${key}`}
                    text={heading?.text}
                  />
                  <ParagraphBody
                    text={articleText}
                    className={`text2r articlepage-text-${getImagePosition(
                      props.imagePosition
                    )}-spacing`}
                  />
                </div>
                {props.imagePosition === 'right' && (
                  <img src={subIcon} alt={props.alt} />
                )}
              </div>
            )}
          </div>
        ))}

      <div className='articlepage-desc'>
        <ParagraphHeading
          id={ELEMENT_IDS.LAST_SECTION}
          text={text?.headings?.second_para}
        />
        <ParagraphBody text={text?.second_para} />
      </div>
      {/* <div className='mobile-articlepage-desc'>
        <ParagraphHeading text={text?.headings?.second_para} />
        <ParagraphBody text={text?.second_para} />
      </div> */}
      <div
        className={`${
          isMobileView
            ? 'mobile-articlepage-section-buttons'
            : 'articlepage-section-buttons'
        }`}>
        {text?.buttons !== undefined &&
          text.buttons.map((button, index) => (
            <div key={index}>
              <div
                className={`button-container ${
                  isMobileView
                    ? 'mobile-articlepage-button'
                    : 'articlepage-button-spacing-right'
                }`}>
                <Link to={button.url}>
                  <Button
                    className={`btn ${getBtnColor(index)} ${
                      isMobileView && 'mobile-articlepage-fullwidth-buttons'
                    }`}>
                    {index === 0 && (text.id === 2 || text.id === 3) && (
                      <FontAwesomeIcon icon={faLongArrowLeft} size='lg' />
                    )}

                    {button.text}
                    {(index === 1 || index === 2) &&
                      (text.id === 1 || text.id === 2) && (
                        <FontAwesomeIcon icon={faLongArrowRight} size='lg' />
                      )}
                  </Button>
                </Link>
              </div>
            </div>
          ))}
        <div className='separator-wrapper'>
          <img src={separator} />
        </div>
        {children}
      </div>
    </div>
  );
}
